import { render } from "./AppMessage.vue?vue&type=template&id=ef6e93f4&scoped=true"
import script from "./AppMessage.vue?vue&type=script&lang=js"
export * from "./AppMessage.vue?vue&type=script&lang=js"

import "./AppMessage.vue?vue&type=style&index=0&id=ef6e93f4&scoped=true&lang=scss"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef6e93f4"]])

export default __exports__